module.exports = __webpack_public_path__ + "media/images/sidebar-88a787ccb903eb6fecad42febba2dda6.png";